import { Link } from "react-router-dom";
import logo from "../images/Logo.png";
import pages from "../content/pages.json";
import posts from "../content/posts.json";
import { PostGrid } from "../components/PostGrid";

export const Home = () => (
  <>
    <section className="hero">
      <img src={logo} alt="Colleen Dixon logo, drawn by Kate Dixon" className="hero-logo" />
      <h1>Hi! I'm Colleen.</h1>
      <p className="lead">
        I'm a creator at heart — I love starting with nothing and turning it
        into something useful or beautiful.
      </p>
      <p>
        Professionally, I'm a software engineer turned application designer.
        I like creating applications that get the job done as efficiently as
        possible, but are also fun and satisfying to use. The user is my number
        one priority; I want to understand the why behind a task and streamline
        a workflow into a beautiful and enjoyable experience.
      </p>
      <p>
        That passion isn't limited to my professional life. You'll find lots of
        random projects here: fiber arts, keyboard construction, my musical
        pursuits (banjo, flute, and recently violin), and a few thrift store
        restorations. I'm also an avid Auburn University fan (War Eagle!) and
        jet around between track, wrestling, dance, cross country, cello, and
        double reed lessons.
      </p>
    </section>

    <section>
      <h2 className="section-title">Explore</h2>
      <div className="topic-grid">
        {pages.map((page, i) => (
          <Link key={page.slug} to={`/${page.slug}`} className={`topic-card accent-${i % 4}`}>
            <h3>{page.title}</h3>
            <p>{page.tagline}</p>
          </Link>
        ))}
        <Link to="/play" className="topic-card accent-play">
          <h3>ThriftQuest</h3>
          <p>Play our family-made thrifting game — every shelf hides a treasure</p>
        </Link>
      </div>
    </section>

    <section>
      <h2 className="section-title">Latest from the blog</h2>
      <PostGrid posts={posts.slice(0, 3)} />
      <p className="see-all">
        <Link to="/blog">See all posts →</Link>
      </p>
    </section>
  </>
);
